import { Controller } from "@hotwired/stimulus"
import {Sortable} from '@shopify/draggable';


// Connects to data-controller="ordering-question"
export default class extends Controller {

  connect() {
    const containerSelector = '.list-group-sortable';

    const sortable = new Sortable(this.element, {
      draggable: '.isDraggable',
      mirror: {
        appendTo: containerSelector,
        constrainDimensions: true,
      },
    });
  }
}
